// Toggle GrandChildren menu
const headerChildMenusx = document.querySelectorAll("li > details[id^='Details-HeaderSubMenu-']");
headerChildMenusx?.forEach(childMenu => {
  //console.log(childMenu);
  childMenu.addEventListener("mouseover", openMenu);
});

function openMenu(event) {
  //console.log(this, this.dataset.handle);
  document.querySelector(`.header__grandchild-item[data-parent="${this.dataset.handle}"]`).dataset.state = "open";
  document.querySelectorAll(`.header__grandchild-item:not([data-parent="${this.dataset.handle}"])`)?.forEach(menu => menu.dataset.state = "close");
}

// Show collection image
const grandChildren = document.querySelectorAll('.header__grandchild-item a');
grandChildren.forEach(el => {
  el.addEventListener("mouseover", getChildImages);
})

const children = document.querySelectorAll("ul.header__submenu.list-menu li a");
children.forEach(el => {
  el.addEventListener("mouseover", getChildImages);
})

function getChildImage(event) {
  console.log(this.dataset.image);
  const image = `<img src="${this.dataset.image}" width="200" loading="lazy">`;
  this.closest(".header__submenu.list-menu").querySelector(".header__featured-collection").innerHTML = this.dataset.image != undefined ? image : "";
  // document.querySelector(".header__featured-collection").innerHTML = image;
}

function getChildImages(event) {
  const imageContainer = this.closest(".header__submenu.list-menu").querySelector(".header__featured-collection");
  
  if (this.dataset.image == undefined) {
    imageContainer.innerHTML = "";
    return;
  }
  
  const arrImages = this.dataset.image.split(",");
  let el = "";
  arrImages.forEach(image => {
    el += `<img src="${image}" width="200" loading="lazy">`;
  })
  this.closest(".header__submenu.list-menu").querySelector(".header__featured-collection").innerHTML = this.dataset.image != undefined ? el : "";
}